export default __webpack_public_path__ + "static/media/logo.fc128360.png";